import { Component, Input, OnInit } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';

/**
 * A component to shorten the process of creating unordered lists.
 * Generates an unordered list based on a passed array.
 */
@Component({
    selector: 'emr-list',
    templateUrl: './emr-list.component.html',
    styleUrls: ['./emr-list.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor],
})
export class EmrListComponent implements OnInit {
  /**
   * The array to render within the <ul> element (see template).
   */
  @Input() list!: any[];

  /**
   * The text to display if the list is empty.
   */
  @Input() emptyText = 'None';

  constructor() {}

  ngOnInit(): void {}

  /**
   * Returns whether the passed list is empty or not.
   */
  get isEmpty() {
    return !(this.list && this.list.length > 0);
  }
}
